import { AppConfig, AppEnv } from "src/app/app.config";

export class FeaturesConfig {

  // *** Define toggles for new/experimental features here ***
  private static readonly definitions: FeatureTogglesCollection = {
    'Group.Members': {
      dev: true,
      staging: false,
      prod: false,
    },
  };

  private static INSTANCE = new FeaturesConfig(FeaturesConfig.definitions);
  static getInstance(): FeaturesConfig { return this.INSTANCE; }
  // for testing
  static setInstance(config: FeaturesConfig) {
    this.INSTANCE = config;
  }

  constructor(
    private readonly toggles: FeatureTogglesCollection
  ) { }

  isEnabled(key: string, env: AppEnv = AppConfig.env): boolean {
    const toggle = this.toggles[key];
    if (!toggle) return false;
    let enabled = toggle[AppEnv[env]];

    // use the 'localhost' value for 'mock' if not defined
    // eslint-disable-next-line sonarjs/no-collapsible-if
    if (typeof enabled === 'undefined') {
      if (env === AppEnv.mock) {
        enabled = toggle[AppEnv[AppEnv.localhost]];
      }
    }

    // use the 'dev' value for 'localhost' if not defined
    // eslint-disable-next-line sonarjs/no-collapsible-if
    if (typeof enabled === 'undefined') {
      if (env === AppEnv.localhost) {
        enabled = toggle[AppEnv[AppEnv.dev]];
      }
    }

    // else default to false
    if (typeof enabled === 'undefined') {
      enabled = false;
    }

    return enabled;
  }
}

export interface FeatureToggle {
	dev: boolean;        
  staging: boolean;
  prod: boolean;
	localhost?: boolean;  // uses value from 'dev' when not defined
  mock?: boolean;       // uses value from 'localhost' when not defined
}

export interface FeatureTogglesCollection {
  [key: string]: FeatureToggle,
}